export default () => ({
  selectedProject: {
    projectId: '',
    name: '',
  },
  selectedZone: '',
  selectedMachineType: '',
  isValidatingProjectBilling: null,
  projectHasBillingEnabled: null,
  projects: [],
  zones: [],
  machineTypes: [],
});
